//LL: 23.01.23: DST_SwitchingDaysField

import * as React from 'react';
import * as _ from 'underscore';

import NumberField from '../../../../../_common/platform/tsx/NumberField';
import DateField from '../../../../../_common/platform/tsx/DateField';

import * as appTheme from '../../../../../_common/platform/ts/appTheme';

import { IGlob } from '../../../../../_common/application/ts/Glob';

// ================ DST_SwitchingDaysField ===================

class DST_SwitchingDaysFieldRow extends React.Component<any, any> {
    constructor(props) {
        super(props);

        //  themeObj={ self.props.themeObj }  sent
    }

    normalize = (value) => {
    };

    processYearChange = (val) => {
        let obj: any = _.clone(this.props.value || {});
        obj.year = val;
        //obj.name = obj.year.toString();

        obj.toSummerDate = null;
        obj.toWinterDate = null;

        this.handleValueChange(obj);
    };
    processYearClick = (e) => {
        let obj: any = _.clone(this.props.value || {});
        //obj.year = 1;
        //obj.name = obj.year.toString();
        obj.year = null;
        this.handleValueChange(obj);
    };

    processToSummerDateChange = (val) => {
        let obj: any = _.clone(this.props.value || {});
        obj.toSummerDate = val;
        this.handleValueChange(obj);
    };

    processToSummerHourFromChange = (val) => {
        let obj: any = _.clone(this.props.value || {});
        obj.toSummerHourFrom = val;
        this.handleValueChange(obj);
    };
    processToSummerHourToChange = (val) => {
        let obj: any = _.clone(this.props.value || {});
        obj.toSummerHourTo = val;
        this.handleValueChange(obj);
    };

    processToWinterDateChange = (val) => {
        let obj: any = _.clone(this.props.value || {});
        obj.toWinterDate = val;
        this.handleValueChange(obj);
    };

    processToWinterHourFromChange = (val) => {
        let obj: any = _.clone(this.props.value || {});
        obj.toWinterHourFrom = val;
        this.handleValueChange(obj);
    };
    processToWinterHourToChange = (val) => {
        let obj: any = _.clone(this.props.value || {});
        obj.toWinterHourTo = val;
        this.handleValueChange(obj);
    };

    handleValueChange = (value) => {
        this.normalize(value);

        delete value.inherited; //LL:  changed => not inherited

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.i); //LL: i not set last ( == add )
        }
    };

    handleRemove = () => {
        if (typeof this.props.onRemove === 'function') {
            this.props.onRemove(this.props.i);
        }
    };

    getRemoveButton = (value, isEmpty) => {
        //if (value.year == null) {
        //    return;
        //}
        if (isEmpty === true) {
            return;
        }

        //LL: "disabled" not used ?
        if (value.disabled === true) {
            return;
        }

        if (value.inherited === true) {
            return <span className="glyphicon glyphicon-arrow-down"></span>;
        }

        return <span className="glyphicon glyphicon-remove" onClick={this.handleRemove}></span>;
    };

    getYear = (value, isEmpty) => {
        //let displayVal = value.year || 1;
        let displayVal = value.year || null;

        if (isEmpty === true) {
            let displayValEmpty = (
                <button type="button" className="btn btn-default btn-sm" onClick={this.processYearClick}>
                    {'Add Year'}
                </button>
            );
            return (
                <div className="entity-select">
                    <div className="content">
                        <span className="value">{displayValEmpty}</span>
                    </div>
                </div>
            );
        }

        let readOnly = value.disabled === true;
        //LL: style="cursor:default" for readonly in StringField

        return (
            <NumberField
                onChange={this.processYearChange}
                value={displayVal}
                integer={true}
                positive={true}
                //min={ 1970 }
                max={2100}
                readOnly={readOnly}
                //allowNull={ false }
                allowNull={true}
                applyOnEnter={true}
            />
        );
    };

    getToSummerDate = (value) => {
        if (value.year == null) {
            return null;
        }
        if (value.year === 1) {
            return null;
        }

        //let displayVal = value.toSummerDate || null;
        //LL: Month/Day of Now or 1/1 ?
        let displayVal: Date = value.toSummerDate;
        if (displayVal == null) {
            //let D0 = new Date();
            //D0.setFullYear(value.year);
            //displayVal = D0;
        }

        let minDate = new Date(value.year, 0, 1);
        let maxDate = new Date(value.year, 11, 31);

        let readOnly = value.disabled === true;
        //LL: style="cursor:default" for readonly in StringField

        return (
            <DateField
                onChange={this.processToSummerDateChange}
                value={displayVal}
                //type={ DateFieldTypes.date }
                type={'date'}
                minDate={minDate}
                maxDate={maxDate}
                hideClearButton={true}
                readOnly={readOnly}
                allowNull={true}
            />
        );
    };

    getToSummerHourFrom = (value) => {
        if (value.year == null) {
            return null;
        }
        if (value.year === 1) {
            return null;
        }

        let displayVal = value.toSummerHourFrom || 2; // null; // 2 -> 3

        let readOnly = value.disabled === true;
        //LL: style="cursor:default" for readonly in StringField

        return (
            <NumberField
                onChange={this.processToSummerHourFromChange}
                value={displayVal}
                integer={true}
                notNegative={true}
                min={0}
                max={23}
                readOnly={readOnly}
                allowNull={false}
                applyOnEnter={true}
            />
        );
    };

    getToSummerHourTo = (value) => {
        if (value.year == null) {
            return null;
        }
        if (value.year === 1) {
            return null;
        }

        let displayVal = value.toSummerHourTo || 3; // null; // 2 -> 3

        let readOnly = value.disabled === true;
        //LL: style="cursor:default" for readonly in StringField

        return (
            <NumberField
                onChange={this.processToSummerHourToChange}
                value={displayVal}
                integer={true}
                notNegative={true}
                min={0}
                max={23}
                readOnly={readOnly}
                allowNull={false}
                applyOnEnter={true}
            />
        );
    };

    getToWinterDate = (value) => {
        if (value.year == null) {
            return null;
        }
        if (value.year === 1) {
            return null;
        }

        //let displayVal = value.toWinterDate || null;
        //LL: Month/Day of Now or 1/1 ?
        let displayVal: Date = value.toWinterDate;
        if (displayVal == null) {
            //let D0 = new Date();
            //D0.setFullYear(value.year);
            //displayVal = D0;
        }

        let minDate = new Date(value.year, 0, 1);
        let maxDate = new Date(value.year, 11, 31);

        let readOnly = value.disabled === true;
        //LL: style="cursor:default" for readonly in StringField

        return (
            <DateField
                onChange={this.processToWinterDateChange}
                value={displayVal}
                //type={ DateFieldTypes.date }
                type={'date'}
                minDate={minDate}
                maxDate={maxDate}
                hideClearButton={true}
                readOnly={readOnly}
                allowNull={true}
            />
        );
    };

    getToWinterHourFrom = (value) => {
        if (value.year == null) {
            return null;
        }
        if (value.year === 1) {
            return null;
        }

        let displayVal = value.toWinterHourFrom || 3; // null;

        let readOnly = value.disabled === true;
        //LL: style="cursor:default" for readonly in StringField

        return (
            <NumberField
                onChange={this.processToWinterHourFromChange}
                value={displayVal}
                integer={true}
                notNegative={true}
                min={0}
                max={23}
                readOnly={readOnly}
                allowNull={false}
                applyOnEnter={true}
            />
        );
    };

    getToWinterHourTo = (value) => {
        if (value.year == null) {
            return null;
        }
        if (value.year === 1) {
            return null;
        }

        let displayVal = value.toWinterHourTo || 2; // null;

        let readOnly = value.disabled === true;
        //LL: style="cursor:default" for readonly in StringField

        return (
            <NumberField
                onChange={this.processToWinterHourToChange}
                value={displayVal}
                integer={true}
                notNegative={true}
                min={0}
                max={23}
                readOnly={readOnly}
                allowNull={false}
                applyOnEnter={true}
            />
        );
    };

    render() {
        let value = this.props.value || {};

        let style1: any = {};
        if (value.disabled === true) {
            style1.backgroundColor = '#eeeeee';
            style1.cursor = 'default';
        }

        let hourTitle = '0-23';
        if (this.props.empty === true || value.year == null) {
            hourTitle = '';
        }

        return (
            <tr style={style1}>
                <td className="cell-remove">{this.getRemoveButton(value, this.props.empty)}</td>
                <td className="cell-year">{this.getYear(value, this.props.empty)}</td>
                <td className="cell-date">{this.getToSummerDate(value)}</td>
                <td className="cell-hour" title={hourTitle}>
                    {this.getToSummerHourFrom(value)}
                </td>
                <td className="cell-hour" title={hourTitle}>
                    {this.getToSummerHourTo(value)}
                </td>
                <td className="cell-date">{this.getToWinterDate(value)}</td>
                <td className="cell-hour" title={hourTitle}>
                    {this.getToWinterHourFrom(value)}
                </td>
                <td className="cell-hour" title={hourTitle}>
                    {this.getToWinterHourTo(value)}
                </td>
            </tr>
        );
    }
}

export default class DST_SwitchingDaysField extends React.Component<
    {
        value?;
        border?: boolean;
        themeObj: appTheme.IValuesCollection;
        glob: IGlob;
        onChange(value): void;
    },
    {}
> {
    private static LastId = 0;

    constructor(props) {
        super(props);

        let id = 0;
        _.each(props.value, (obj: any) => {
            if (obj.id != null && obj.id > id) {
                id = obj.id;
            }
        });
        DST_SwitchingDaysField.LastId = id;
    }

    //LL: NOTE about Reorder vs Sorting: =============================
    //   Items can either reordered by user's DragDrop or sorted by some internal algorithm (alphabetically here)
    //   Previous solution was Reorder, but it is not convenient and mixing own/parent items is bad
    //   So, now it will be Sorting, see function getSortedValuesByName
    //============================================================================

    handleValueChange(value) {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    }

    addRow = (obj) => {
        let arr = this.props.value.slice(0);

        //LL: Year is set
        // obj.toSummer  Winter  ...
        obj.toSummerHourFrom = 2;
        obj.toSummerHourTo = 3;
        obj.toWinterHourFrom = 3;
        obj.toWinterHourTo = 2;

        obj.disabled = false;

        DST_SwitchingDaysField.LastId++;
        obj.id = DST_SwitchingDaysField.LastId;

        arr.push(obj);
        this.handleValueChange(arr);
    };

    changeRow = (obj, i) => {
        let arr = this.props.value.slice(0);
        let prev = arr.splice(i, 1, obj)[0];
        this.handleValueChange(arr);
    };

    removeRow = (i) => {
        let arr = this.props.value.slice(0);
        arr.splice(i, 1);
        this.handleValueChange(arr);
    };

    getSortedValuesByNumeric(values, fieldName) {
        let arr = values.slice(0);
        arr.sort(function (a: any, b: any) {
            let a1 = a[fieldName];
            let b1 = b[fieldName];

            //LL: empty - the last:
            //if (a1 === '') {
            //    return 1;
            //}
            //if (b1 === '') {
            //    return -1;
            //}

            if (a1 > b1) {
                return 1;
            }
            if (a1 < b1) {
                return -1;
            }
            return 0; // a = b
        });

        let indices = _.map(arr, function (obj: any, i) {
            let j = _.indexOf(values, obj);
            return j;
        });

        return { arr: arr, indices: indices };
    }

    render() {
        //LL: "optionThemeOwnAndParent" is from ThemeField.tsx  EditComponentDepsWrapper.render:
        let objThemeOwnAndParent = appTheme.getThemeOwnAndParentvalues(this.props);
        let ownValues = objThemeOwnAndParent.ownValues;
        let parentValues = objThemeOwnAndParent.parentValues;

        //LL: something wrong is here, so comment and see below without Sort
        let aaa = this.getSortedValuesByNumeric(this.props.value, 'year'); //LL: DST return { arr: arr, indices: indices };
        //let aaa = appTheme.getSortedValuesByName(this.props.value); //LL:  return { arr: arr, indices: indices };

        //let rows = _.map(
        //    aaa.arr,
        //    (obj: any, i) => {
        //        let obj2: any = appTheme.setProperInheritedFlag(obj, ownValues, parentValues, 'DST_SwitchingDaysField');
        //        //LL: may be null, if just removed
        //        if (obj2 == null) {
        //            return null;
        //        }
        //
        //        let j = aaa.indices[i];
        //
        //        let keyR = '';
        //        if (obj2 != null && obj2.year != null) {
        //            keyR = obj2.year;
        //        }
        //
        //        //  i={ i }  was
        //        return (
        //            <DST_SwitchingDaysFieldRow
        //                key={ i + '-' + keyR }
        //                i={ j }
        //                value={ obj2 }
        //                themeObj={ this.props.themeObj }
        //                onChange={ this.changeRow }
        //                onRemove={ this.removeRow }
        //                glob={ this.props.glob }
        //            />
        //        );
        //    }
        //);

        //LL: without Sort:
        let rows = _.map(this.props.value, (obj: any, i) => {
            let obj2: any = appTheme.setProperInheritedFlag(obj, ownValues, parentValues, 'DST_SwitchingDaysField');
            //LL: may be null, if just removed
            if (obj2 == null) {
                return null;
            }

            //let j = aaa.indices[i];
            let j = i;

            let keyR = '';
            if (obj2 != null && obj2.year != null) {
                keyR = obj2.year;
            }

            return (
                <DST_SwitchingDaysFieldRow
                    key={i + '-' + keyR}
                    i={j}
                    value={obj2}
                    themeObj={this.props.themeObj}
                    onChange={this.changeRow}
                    onRemove={this.removeRow}
                    glob={this.props.glob}
                />
            );
        });

        let showTableHeaders = rows.length > 0;

        let style1 = { marginBottom: 5 }; // class "table" has margin-bottom:20px

        let style2 = {
            paddingBottom: 15
        };

        return (
            <div className={'gantt-dst-days-field'}>
                <div className={'div-container'} style={style2}>
                    <p style={{ marginBottom: '3px', maxWidth: 'max-content' }}>
                        Define for each required Year according to actual TimeZone.
                    </p>
                    <p style={{ maxWidth: 'max-content' }}>
                        {'See Document Guide (IANA timezone database): '}
                        <a href="http://www.iana.org/time-zones" target="_blank">
                            http://www.iana.org/time-zones
                        </a>
                    </p>
                    <table className={'table' + (this.props.border === true ? ' table-bordered' : '')} style={style1}>
                        {showTableHeaders === true ? (
                            <thead>
                                <tr>
                                    <th className="cell-remove"></th>
                                    <th className="cell-year">{'Year'}</th>
                                    <th className="cell-date">{'ToSummer date'}</th>
                                    <th className="cell-hour" title="0-23">
                                        {'ToSummer Hour From'}
                                    </th>
                                    <th className="cell-hour" title="0-23">
                                        {'ToSummer Hour To'}
                                    </th>
                                    <th className="cell-date">{'ToWinter date'}</th>
                                    <th className="cell-hour" title="0-23">
                                        {'ToWinter Hour From'}
                                    </th>
                                    <th className="cell-hour" title="0-23">
                                        {'ToWinter Hour To'}
                                    </th>
                                </tr>
                            </thead>
                        ) : null}
                        <tbody>
                            {rows}
                            <DST_SwitchingDaysFieldRow
                                empty={true}
                                themeObj={this.props.themeObj}
                                onChange={this.addRow}
                                glob={this.props.glob}
                            />
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
